import { PERMISSIONS } from '@bridesk/contracts';
import {
  adminModule,
  deliveriesModule,
  routinesModule,
  settingsModule,
  type TeamsKitAppConfig,
  teamsModule,
} from '@britania/teams-kit-react';
import { approvalsModule } from '#src/modules/approvals/approvals.module';

/**
 * O BriDesk para o kit. Navegação lateral, rotas, breadcrumb e Início saem
 * de `modules`, nesta ordem. Para criar um módulo:
 * `src/modules/<nome>/<nome>.module.ts` com as páginas, e uma linha aqui.
 */
export const appConfig: TeamsKitAppConfig = {
  brand: {
    name: 'BriDesk',
    tagline: 'Chamados no Teams',
    description:
      'Lembretes de chamados do Softdesk no Teams: configure, confira e acompanhe por aqui.',
    logoUrl: '/icon.png',
  },
  permissions: PERMISSIONS,
  modules: [
    routinesModule,
    approvalsModule,
    deliveriesModule,
    adminModule,
    teamsModule,
    settingsModule,
  ],
};
